import Controller from "./bulkInvoiceItemTypesUploads.controller";
import template from "./bulkInvoiceItemTypesUploads.html";

const bulkInvoiceItemTypesUploads = {
  template,
  controller: Controller,
};

export default bulkInvoiceItemTypesUploads;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploads/bulkInvoiceItemTypesUploads.component.js